var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "route-table_svg__a",
    x1: 10.56,
    y1: 7.77,
    x2: 10.56,
    y2: 19.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "route-table_svg__b",
    x1: 10.23,
    y1: 1.63,
    x2: 11.07,
    y2: 12.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.23 17.17A1.21 1.21 0 0017.46 16v-.2c-.49-3.86-2.69-7-6.89-7s-6.48 2.66-6.91 7a1.24 1.24 0 001.1 1.36h11.47z",
    fill: "url(#route-table_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.57 9.71a3.86 3.86 0 01-2.1-.61l2.08 5.42 2.06-5.39a3.83 3.83 0 01-2.04.58z",
    fill: "#fff",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.57,
    cy: 5.84,
    r: 3.87,
    fill: "url(#route-table_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.88V1a.16.16 0 00-.16-.17H4.57a.17.17 0 00-.18.17v4.71a.18.18 0 01-.17.17H3.1a.12.12 0 01-.1-.12V4.45a.11.11 0 00-.19-.08L.59 6.57a.16.16 0 000 .24L2.79 9A.11.11 0 003 8.93V7.61a.11.11 0 01.1-.11h2.74A.17.17 0 006 7.33V5.88z",
    fill: "#0078d4"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMTAuNTYiIHkxPSI3Ljc3IiB4Mj0iMTAuNTYiIHkyPSIxOS4yNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iLjIyIiBzdG9wLWNvbG9yPSIjMzJkNGY1Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTk4YWIzIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSIxMC4yMyIgeTE9IjEuNjMiIHgyPSIxMS4wNyIgeTI9IjEyLjA0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIuMjIiIHN0b3AtY29sb3I9IiMzMmQ0ZjUiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxOThhYjMiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBkPSJNMTYuMjMgMTcuMTdBMS4yMSAxLjIxIDAgMDAxNy40NiAxNnYtLjJjLS40OS0zLjg2LTIuNjktNy02Ljg5LTdzLTYuNDggMi42Ni02LjkxIDdhMS4yNCAxLjI0IDAgMDAxLjEgMS4zNmgxMS40N3oiIGZpbGw9InVybCgjYSkiLz48cGF0aCBkPSJNMTAuNTcgOS43MWEzLjg2IDMuODYgMCAwMS0yLjEtLjYxbDIuMDggNS40MiAyLjA2LTUuMzlhMy44MyAzLjgzIDAgMDEtMi4wNC41OHoiIGZpbGw9IiNmZmYiIG9wYWNpdHk9Ii44Ii8+PGNpcmNsZSBjeD0iMTAuNTciIGN5PSI1Ljg0IiByPSIzLjg3IiBmaWxsPSJ1cmwoI2IpIi8+PHBhdGggZD0iTTYgNS44OFYxYS4xNi4xNiAwIDAwLS4xNi0uMTdINC41N2EuMTcuMTcgMCAwMC0uMTguMTd2NC43MWEuMTguMTggMCAwMS0uMTcuMTdIMy4xYS4xMi4xMiAwIDAxLS4xLS4xMlY0LjQ1YS4xMS4xMSAwIDAwLS4xOS0uMDhMLjU5IDYuNTdhLjE2LjE2IDAgMDAwIC4yNEwyLjc5IDlBLjExLjExIDAgMDAzIDguOTNWNy42MWEuMTEuMTEgMCAwMS4xLS4xMWgyLjc0QS4xNy4xNyAwIDAwNiA3LjMzVjUuODh6IiBmaWxsPSIjMDA3OGQ0Ii8+PC9zdmc+";
export { SvgRouteTable as ReactComponent };